<template>
    <div class="search-widgetCategoryBar">
        <div class="search-widgetCategoryBar__searchBtn"
             @click="$store.commit('OPEN_SEARCH_DIALOG')">
            <i class="icon-search"></i>
        </div>
        <v-dialog content-class="dialog-search" max-width="572px"
                  v-model="$store.state.dialogs.searchDialog"
                  :persistent="isDialogPersistent"
                  v-if="$store.state.dialogs.searchDialog">
            <search-popup @close="$store.commit('CLOSE_SEARCH_DIALOG')"/>
        </v-dialog>
    </div>
</template>

<script>
import DialogSettings from "../../../../../src/mixins/dialogSettings";
import apiData from "../../../../../src/mixins/apiData";

export default {
    name: "SearchCatalogBar",

    mixins: [DialogSettings, apiData],
}
</script>

<style lang="sass">
@import "sass/components/layout/SearchCatalogBar"
</style>